import { Canvas, CanvasEvents } from 'fabric';

export class FabricEventGroupManager<TGroup extends string> {
  private canvas: Canvas | null = null;
  private disposersByGroup: Record<TGroup, Array<() => void>>;

  constructor(groups: readonly TGroup[], canvas?: Canvas | null) {
    this.disposersByGroup = groups.reduce(
      (acc, group) => {
        acc[group] = [];
        return acc;
      },
      {} as Record<TGroup, Array<() => void>>
    );
    this.canvas = canvas ?? null;
  }

  setCanvas(canvas: Canvas | null): void {
    this.canvas = canvas;
  }

  add<K extends keyof CanvasEvents>(
    group: TGroup,
    event: K,
    handler: (this: Canvas, opt: CanvasEvents[K]) => void
  ): void {
    if (!this.canvas) return;
    const disposer = this.canvas.on(event, handler as any);
    this.disposersByGroup[group].push(disposer);
  }

  clear(group: TGroup): void {
    const disposers = this.disposersByGroup[group];
    while (disposers.length > 0) {
      const dispose = disposers.pop();
      try {
        dispose?.();
      } catch (_) {
        // Ignore stale disposer failures during teardown.
      }
    }
  }

  clearAll(): void {
    (Object.keys(this.disposersByGroup) as TGroup[]).forEach((group) => this.clear(group));
  }
}
